






















import Vue from 'vue'
import { TOKEN, LAST_LOGGED_IN_USER, LOGGED_IN_USER } from '@/store'
import { apiRoutes } from '@/helpers/ApiRoutes'
import Utils from '@/helpers/Utils'

export const SIMULATOR = 'simulator'

export default Vue.extend({
  name: 'Login',

  data: () => ({
    error: false
  }),

  mounted () {
    this.handleLogin()
  },

  methods: {
    handleLogin () {
      localStorage.clear()
      const { tempToken } = this.$route.params
      if (typeof tempToken === 'undefined') {
        window.location.href = this.$axios.defaults.baseURL + apiRoutes.pwaLogin
      } else {
        this.loginUser(tempToken)
      }
    },
    loginUser (tempToken: string) {
      const postParams = new URLSearchParams()
      postParams.append('tempToken', tempToken)
      this.$axios.post(apiRoutes.pwaValidateToken, postParams)
        .then(res => {
          const result = res.data.data
          if (result.success) {
            this.error = false
            const lastLoggedInUser = Vue.prototype.$getCookie('last-logged-in-user')
            // If we're setting up the simulator, a token should be saved in session, not local storage
            if (Object.prototype.hasOwnProperty.call(result, 'isSimulator') && result.isSimulator) {
              sessionStorage.setItem(SIMULATOR, SIMULATOR)
              result.appVersion && sessionStorage.setItem('appVersion', result.appVersion)
              sessionStorage.setItem(TOKEN, result.token)
              lastLoggedInUser && sessionStorage.setItem(LAST_LOGGED_IN_USER, lastLoggedInUser)
            } else {
              localStorage.setItem(TOKEN, result.token)
              lastLoggedInUser && localStorage.setItem(LAST_LOGGED_IN_USER, lastLoggedInUser)
            }
            this.setUserData()
            this.$store.dispatch('commitToken', result.token)
            lastLoggedInUser && this.$store.dispatch('commitLastLoggedInUser', lastLoggedInUser)
            this.$router.push({ name: 'Home' })
            location.reload()
          } else {
            this.error = true
          }
        })
        .catch(() => {
          this.error = true
        })
    },
    async retryLogin () {
      await this.$router.push({ name: 'Login' })
      Utils.reloadPage(this.$router)
    },
    setUserData () {
      localStorage.setItem(
        LOGGED_IN_USER,
        JSON.stringify(
          {
            email: decodeURIComponent(this.$route.query.email as string),
            avatar: decodeURIComponent(this.$route.query.avatar_url as string),
            fullName: decodeURIComponent(this.$route.query.fullName as string)
          }
        )
      )
    }
  }
})
